import React from 'react';
import moment from 'moment';
import { ChannelPreviewUIComponentProps, useChatContext, Avatar } from 'stream-chat-react';
import Badge from '@mui/material/Badge'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'

import { StreamChatType } from '../../types';
import { Box } from '@mui/material';
import { AccessTime } from '@mui/icons-material';

type DirectMessagingChannelPreviewProps = Pick<ChannelPreviewUIComponentProps<StreamChatType>, 'channel'>;

export const DirectMessagingChannelPreview = ({channel}: DirectMessagingChannelPreviewProps) => {
  const { client } = useChatContext<StreamChatType>();


  const members = Object.values(channel.state.members).filter(
    ({ user }) => user?.id !== client.userID,
  );
  const defaultName = 'Johnny Blaze';

  if (!members.length || members.length === 1) {
    const member = members[0];
    return (
      <ListItem divider dense>
        <ListItemAvatar>
        <Badge badgeContent={channel.state.unreadCount} color="error" >
          <Avatar image={member.user?.image} name={member.user?.name || member.user?.id} size={32} />
          </Badge>
        </ListItemAvatar>
        <ListItemText primaryTypographyProps={{ color: '#fff' }} secondaryTypographyProps={{ component: 'div', color: '#fff', fontWeight: 300, fontSize: 12 }} primary={member?.user?.name || member?.user?.id || defaultName}
        secondary={<Box sx={{ display: 'flex', alignItems: 'center'}} >
        <AccessTime sx={{ fontSize: 12, mr: 0.5}} color="secondary" />
        <Box>{moment(channel?.data?.last_message_at || new Date()).format('ll')}</Box>
        </Box> }
         />
      </ListItem>
    );
  }

  return (
    <ListItem divider dense>
      <ListItemAvatar>
      <Badge badgeContent={channel.state.unreadCount} color="error"  >
      <span>
          <Avatar image={members[0].user?.image} name={members[0].user?.name || members[0].user?.id} size={22} />
        </span>
          <Avatar image={members[1].user?.image} name={members[1].user?.name || members[1].user?.id} size={22} />
        </Badge>
      </ListItemAvatar>
      <ListItemText primaryTypographyProps={{ color: '#fff' }} secondaryTypographyProps={{ component: 'div', color: '#fff', fontWeight: 300, fontSize: 12 }}
      primary={`${members[0].user?.name || members[0].user?.id || defaultName}, ${members[1].user?.name || members[1].user?.id || defaultName}`}
      secondary={<Box sx={{ display: 'flex', alignItems: 'center'}} >
        <AccessTime sx={{ fontSize: 12, mr: 0.5}} color="secondary" />
        <Box>{moment(channel?.data?.last_message_at || new Date()).format('ll')}</Box>
        </Box> }
         />
    </ListItem>
  );
};